export const pictureIcon = `
<svg fill="currentColor" viewBox="-20 -20 512 512">
  <path d="M85 405c-23 0-42-19-42-42V128c0-24 19-43 42-43h320c24 0 43 19 43 43v235c0 23-19 42-43 42H85zm278-119-33 33-21 21-1 1-22 22h119v-34l-42-43zm-192-53-86 85v45h141l37-38-92-92zm234-105H85v130l55-55c16-16 41-17 58-3l3 3 92 92 7-6 32-33c17-17 44-17 61 0l12 12V128zm-96 43a32 32 0 1 1 0 64 32 32 0 0 1 0-64z"/>
</svg>
`;
export const pictureCropIcon = `
<svg fill="currentColor" viewBox="0 0 1024 1024" transform="scale(.9)">
  <path d="M725 640h86V299c0-47-39-86-86-86H384v86h341v341zm-426 85V43h-86v170H43v86h170v426c0 47 39 86 86 86h426v170h86V811h170v-86H299z"/>
</svg>
`;
export const pictureRotateIcon = `
<svg fill="currentColor" viewBox="0 0 1024 1024">
  <path d="M534 226V126a4 4 0 0 0-7-4L324 255a4 4 0 0 0 0 7l203 133a4 4 0 0 0 7-4v-86a343 343 0 0 1 343 343h79c0-233-189-422-422-422zm202 246H190a44 44 0 0 0-44 44v335a44 44 0 0 0 44 44h546a44 44 0 0 0 44-44V516a44 44 0 0 0-44-44zm-35 344H226V552h475z"/>
</svg>
`;
export const pictureFloatLeftIcon = `
<svg fill="currentColor" viewBox="0 0 20 20">
  <path d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/>
  <path d="M12 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-1.5.5h-7V12h7V7.5z"/>
</svg>
`;
export const pictureFloatRightIcon = `
<svg fill="currentColor" viewBox="0 0 20 20">
  <path d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/>
  <path d="M18 7v5.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-1.5.5h-7V12h7V7.5z"/>
</svg>
`;
export const pictureRestoreIcon = `
<svg fill="currentColor" viewBox="0 0 1024 1024">
  <path d="M939 512a384 384 0 0 1-384 384 379 379 0 0 1-220-70 22 22 0 0 1-9-15 21 21 0 0 1 6-17l30-31a21 21 0 0 1 27-3 295 295 0 0 0 166 51 299 299 0 1 0-299-299h101a21 21 0 0 1 15 6l9 9a21 21 0 0 1 0 30L230 708a22 22 0 0 1-30 0L49 557a21 21 0 0 1 0-30l9-9a21 21 0 0 1 15-6h98a384 384 0 0 1 768 0z"/>
</svg>
`;
export const pictureRemoveIcon = `
<svg fill="currentColor" viewBox="0 0 512 512">
  <path d="M431 81c9 10 9 26 0 35L291 256l140 140a25 25 0 0 1-35 35L256 291 116 431a25 25 0 0 1-35-35l140-140L81 116a25 25 0 1 1 35-35l140 140L396 81c9-9 25-9 35 0z"/>
</svg>
`;
//# sourceMappingURL=icon.js.map